require.register("modules/m0x/a04/page-46/page-46", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_46 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_46;

  
});

